import React, { useState, useRef } from 'react'

export default function FileUpload({ onFileUpload = () => { }, accept = "image/*,video/*" }) {
    const [dragActive, setDragActive] = useState(false)
    const [files, setFiles] = useState([])
    const inputRef = useRef(null)

    const handleDrag = (e) => {
        e.preventDefault()
        e.stopPropagation()
        if (e.type === "dragenter" || e.type === "dragover") {
            setDragActive(true)
        } else if (e.type === "dragleave") {
            setDragActive(false)
        }
    }
    const handleRemoveFile = (indexToRemove) => {
        setFiles(prevFiles => {
            const newFiles = prevFiles.filter((_, index) => index !== indexToRemove)
            onFileUpload(newFiles) // Notify parent component of updated files
            return newFiles
        })
    }
    const handleDrop = (e) => {
        e.preventDefault()
        e.stopPropagation()
        setDragActive(false)
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            handleFiles(e.dataTransfer.files)
        }
    }

    const handleChange = (e) => {
        e.preventDefault()
        if (e.target.files && e.target.files[0]) {
            handleFiles(e.target.files)
        }
    }

    const handleFiles = (fileList) => {
        const validFiles = Array.from(fileList).filter(file => {
            const fileType = file.type;
            return fileType.startsWith('image/') || fileType.startsWith('video/');
        });
        setFiles(prevFiles => [...prevFiles, ...validFiles]);
        onFileUpload(validFiles);
    }

    const onButtonClick = () => {
        inputRef.current?.click()
    }

    return (
        <div className="w-full max-w-md mx-auto">
            <div
                className={`relative border-2  rounded-lg p-14 text-center transition-colors ${dragActive ? 'border-primary bg-primary/10' : 'border-muted-foreground'
                    }`}
                onDragEnter={handleDrag}
                onDragLeave={handleDrag}
                onDragOver={handleDrag}
                onDrop={handleDrop}
                onClick={onButtonClick}
            >
                <input
                    ref={inputRef}
                    type="file"
                    className="hidden"
                    multiple
                    onChange={handleChange}
                    accept={accept}
                />
            <div className='flex justify-center'>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C10.9583 1.99979 9.93878 2.28654 9.06433 2.82568C8.18988 3.36482 7.49783 4.13333 7.0716 5.03857C7.01097 5.16835 6.94886 5.2975 6.8853 5.426L6.8673 5.42686C6.8097 5.42857 6.7314 5.42857 6.6 5.42857C5.64522 5.42857 4.72955 5.78979 4.05442 6.43278C3.37928 7.07576 3 7.94783 3 8.85714C3 9.76646 3.37928 10.6385 4.05442 11.2815C4.72955 11.9245 5.64522 12.2857 6.6 12.2857H6.7548L8.5548 10.5714H6.6C6.12261 10.5714 5.66477 10.3908 5.32721 10.0693C4.98964 9.74784 4.8 9.3118 4.8 8.85714C4.8 8.40249 4.98964 7.96645 5.32721 7.64496C5.66477 7.32347 6.12261 7.14286 6.6 7.14286H6.6576C6.8448 7.14286 7.0626 7.14371 7.2426 7.10857C7.46666 7.07208 7.68084 6.9934 7.8726 6.87714C8.0895 6.74343 8.2389 6.57714 8.3523 6.42543C8.42178 6.3277 8.48231 6.22447 8.5332 6.11686C8.5812 6.02143 8.64 5.89914 8.7096 5.75L8.7132 5.74143C8.99708 5.13728 9.45846 4.62428 10.0417 4.26431C10.6249 3.90435 11.305 3.71282 12 3.71282C12.695 3.71282 13.3751 3.90435 13.9583 4.26431C14.5415 4.62428 15.0029 5.13728 15.2868 5.74143L15.2913 5.75C15.3603 5.89857 15.4188 6.02086 15.4668 6.11686C15.5082 6.2 15.5694 6.32086 15.6477 6.42543C15.7611 6.57629 15.9096 6.74343 16.1274 6.878C16.3452 7.01171 16.5657 7.07257 16.7574 7.10943C16.9374 7.14371 17.1552 7.14371 17.3424 7.14371L17.4 7.14286C17.8774 7.14286 18.3352 7.32347 18.6728 7.64496C19.0104 7.96645 19.2 8.40249 19.2 8.85714C19.2 9.3118 19.0104 9.74784 18.6728 10.0693C18.3352 10.3908 17.8774 10.5714 17.4 10.5714H15.4452L17.2452 12.2857H17.4C18.3548 12.2857 19.2705 11.9245 19.9456 11.2815C20.6207 10.6385 21 9.76646 21 8.85714C21 7.94783 20.6207 7.07576 19.9456 6.43278C19.2705 5.78979 18.3548 5.42857 17.4 5.42857C17.2686 5.42857 17.1903 5.42857 17.1327 5.42686H17.1147L17.0922 5.38143C17.0365 5.26762 16.9819 5.15333 16.9284 5.03857C16.5022 4.13333 15.8101 3.36482 14.9357 2.82568C14.0612 2.28654 13.0417 1.99979 12 2Z" fill="#5F6368" />
                    <path d="M11.9994 13.4976L11.3934 12.8916L11.9994 12.2856L12.6054 12.8916L11.9994 13.4976ZM12.8566 21.2119C12.8566 21.4393 12.7663 21.6573 12.6055 21.818C12.4448 21.9788 12.2267 22.0691 11.9994 22.0691C11.7721 22.0691 11.5541 21.9788 11.3933 21.818C11.2326 21.6573 11.1423 21.4393 11.1423 21.2119H12.8566ZM7.96484 16.3202L11.3934 12.8916L12.6054 14.1036L9.17684 17.5322L7.96484 16.3202ZM12.6054 12.8916L16.034 16.3202L14.822 17.5322L11.3934 14.1036L12.6054 12.8916ZM12.8566 13.4976V21.2119H11.1423V13.4976H12.8566Z" fill="#5F6368" />
                </svg>
            </div>

                <h2 className=" mb-2">Ziehen und legen Sie Ihre Dateien hier ab</h2>
                <p className="text-sm text-muted-foreground">Es werden nur Bild- und Videodateien unterstützt</p>
            </div>
            {files.length > 0 && (
                <div className="mt-4">
                    <h3 className="text-sm font-semibold mb-2">Hochgeladene Dateien:</h3>
                    <ul className="space-y-2">
                        {files.map((file, index) => (
                            <li key={index} className="flex items-center justify-between text-sm bg-gray-50 p-2 rounded">
                                <div className="flex items-center">
                                    <svg
                                        className="mr-2 h-4 w-4"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
                                        <polyline points="14 2 14 8 20 8" />
                                    </svg>
                                    {file.name}
                                </div>
                                <button
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        handleRemoveFile(index)
                                    }}
                                    className="text-gray-500 hover:text-red-500 p-1"
                                    aria-label="Remove file"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <line x1="18" y1="6" x2="6" y2="18" />
                                        <line x1="6" y1="6" x2="18" y2="18" />
                                    </svg>
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    )
}